import { Box, Grid, Typography } from "@mui/material";
import downArrow from "assets/icons/down_arrow.png";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext } from "react";
import { HOME_BODY_COLOR } from "styles/oneOffColor";

import StyledLargeButton from "components/Styled/Button/StyledLargeButton";

interface Props {
  handleNext: () => void;
  finishSetUpLater: () => void;
}

const AutopilotOnboardingWelcomeForm = ({
  handleNext,
  finishSetUpLater,
}: Props) => {
  const { organizationAutopilotProfile } = useContext(OrganizationUserContext);

  return (
    <>
      <Grid
        item
        alignItems={"center"}
        container
        sx={{ backgroundColor: HOME_BODY_COLOR, borderRadius: 4, p: 3 }}
      >
        <Grid item xs={12} md={6} sx={{ p: 3 }}>
          <Typography>Welcome to</Typography>
          <Typography variant="h2" sx={{ mb: 2, fontSize: { xs: 20, md: 40 } }}>
            Bento Autopilot
          </Typography>

          <Typography gutterBottom sx={{ fontSize: 18, mb: 2 }}>
            <strong>
              You're just one step away from putting your outreach on autopilot.
            </strong>
          </Typography>

          <Typography sx={{ fontSize: 18 }}>
            Setup takes 5-10 minutes. You can pause and come back anytime from
            your dashboard.
          </Typography>
        </Grid>

        <Grid item xs md sx={{ p: 3 }}>
          <Box sx={{ backgroundColor: "white", p: 3, borderRadius: 4 }}>
            <Typography
              textAlign={"center"}
              gutterBottom
              variant="h6"
              sx={{ color: "purple.dark", textTransform: "uppercase" }}
            >
              Automated Outreach
            </Typography>
            <Typography textAlign={"center"}>
              Bento Autopilot unlocks{" "}
              {organizationAutopilotProfile?.planConfig?.monthlyLimit} automated
              email pitches per month.
            </Typography>

            <Box
              component="img"
              src={downArrow}
              sx={{ width: 15, my: 3, display: "block", mx: "auto" }}
            />

            <Typography
              textAlign={"center"}
              gutterBottom
              variant="h6"
              sx={{ color: "purple.dark", textTransform: "uppercase" }}
            >
              Hands-Free Pitching
            </Typography>
            <Typography textAlign={"center"}>
              Bento finds and pitches brands for you automatically.
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid
        container
        justifyContent="center"
        sx={{ mt: { xs: 2, md: 6 }, gap: 2 }}
      >
        <StyledLargeButton
          color="secondary"
          disableElevation
          styles={{ px: 3, fontSize: 16 }}
          onClick={finishSetUpLater}
        >
          I'll do it later
        </StyledLargeButton>
        <StyledLargeButton
          disableElevation
          styles={{ px: 3, fontSize: 16 }}
          onClick={handleNext}
        >
          Let's Get Started{" "}
        </StyledLargeButton>
      </Grid>
    </>
  );
};

export default AutopilotOnboardingWelcomeForm;
